<template>
  <Icon>
    <svg slot="svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs></defs>
      <g id="icons/status/wymaga-oplaty" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
        <circle id="Oval" fill="#FF7C00" cx="12" cy="12" r="10"></circle>
        <g id="Icons8-IN-Progress" transform="translate(10.000000, 5.000000)" fill="#FFFFFF" fill-rule="nonzero">
          <path d="M2,14 C3.1045695,14 4,13.1045695 4,12 C4,10.8954305 3.1045695,10 2,10 C0.8954305,10 0,10.8954305 0,12 C0,13.1045695 0.8954305,14 2,14 Z M0,1.77777778 C0,0.795938223 0.8954305,0 2,0 C3.1045695,0 4,0.795938223 4,1.77777778 L4,6.22222222 C4,7.20406178 3.1045695,8 2,8 C0.8954305,8 0,7.20406178 0,6.22222222 L0,1.77777778 Z" id="Combined-Shape"></path>
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: "DsAlertIcon",
  components: {
    Icon
  }
};
</script>


// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-alert-icon.vue